export default __webpack_public_path__ + "static/media/lender.0e52a93c.png";